import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { notification } from 'antd';
import { v1 as uuidv1 } from 'uuid';
import { api } from '@seaoil/component-lib';

import AsyncAutoComplete from './AsyncAutoComplete';

const { mySEAOIL } = api;

function PayeeField({
  placeholder,
  disabled,
  companyCode,
  onInputSelect,
}) {
  const conf = { pay_group_lookup_code: '' };
  const { pay_group_lookup_code } = conf;

  const [itemPayee, setItemPayee] = useState([]);
  const [loading, isLoading] = useState(false);
  const [key, setKey] = useState(uuidv1());
  const [options, setOptions] = useState([]);
  const retryLimit = 5;
  let retryCount = 0;

  const loadPayee = async () => {
    try {
      isLoading(true);

      const items = await mySEAOIL.datawarehouse.view({
        viewName: 'seaoil_payee',
        schema: 'erp',
        filters: (() => {
          const output = [];

          output.push({
            key: 'subsidiary_id',
            operation: Buffer.from('=').toString('base64'),
            value: companyCode,
          });

          output.push({
            key: 'enabled_flag',
            operation: Buffer.from('=').toString('base64'),
            value: 'Y',
          });

          if (pay_group_lookup_code) {
            output.push({
              key: 'pay_group_lookup_code',
              operation: Buffer.from('=').toString('base64'),
              value: pay_group_lookup_code,
            });
          }

          return output;
        })(),
        orderBy: [
          {
            field: 'vendor_name',
            value: 'ASC',
          },
        ],
        limit: 15000,
      }).send();

      setItemPayee(items.records);
    } catch (e) {
      if (retryCount > retryLimit) {
        notification.error({ message: 'Unable to load payees after multiple retries. Kindly contact supportdesk@seaoil.com.ph' });
      } else {
        notification.error({ message: 'Unable to load payees. Retrying after 2 seconds...' });
        setTimeout(loadPayee, 2000);
        retryCount += 1;
      }
    } finally {
      isLoading(false);
    }
  };

  useEffect(() => {
    setOptions([]);
    if (companyCode) {
      loadPayee();
    }
  }, [companyCode]);

  useEffect(() => {
    setKey(uuidv1());
    if (!Array.isArray(itemPayee)) {
      return;
    }

    setOptions(itemPayee.map(({
      vendor_name,
    }) => ({
      value: vendor_name,
      label: vendor_name,
    })));
  }, [itemPayee]);

  return (
    <AsyncAutoComplete
      placeholder={placeholder}
      key={key}
      disabled={disabled}
      loading={loading}
      options={options}
      onInputSelect={(vendor_name) => {
        if (itemPayee) {
          onInputSelect(itemPayee.find((item) => item.vendor_name === vendor_name));
        }
      }}
    />
  );
}

PayeeField.propTypes = {
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.string.isRequired,
  companyCode: PropTypes.string.isRequired,
  onInputSelect: PropTypes.string.isRequired,
};

export default PayeeField;
